export enum TypeOfContractsView {
    PropertyProfilePage,
    MultipleProperties,
}

export interface ClientSelectableOptions {
    value: string;
    name: string;
}
